import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "minValue", "maxValue", "valueLabels", "largeValueLabels", "hideValueBar", "step", "onChange", "onDragEnd", "className", "disabled"];
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classname from 'classnames';
var Slider = function Slider(props) {
  var value = props.value,
    minValue = props.minValue,
    maxValue = props.maxValue,
    valueLabels = props.valueLabels,
    largeValueLabels = props.largeValueLabels,
    hideValueBar = props.hideValueBar,
    step = props.step,
    onChange = props.onChange,
    onDragEnd = props.onDragEnd,
    className = props.className,
    disabled = props.disabled,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(value ? value : minValue),
    _useState2 = _slicedToArray(_useState, 2),
    currentValue = _useState2[0],
    setCurrentValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isChanging = _useState4[0],
    setIsChanging = _useState4[1];
  useEffect(function () {
    if (value >= minValue && value <= maxValue) {
      setCurrentValue(value);
    }
  }, [value, minValue, maxValue]);
  var handleChange = function handleChange(event) {
    var newValue = parseInt(event.target.value, 10);
    setCurrentValue(newValue);
    setIsChanging(true);
    onChange(newValue);
  };
  var onMouseUp = function onMouseUp() {
    setIsChanging(false);
    onDragEnd(currentValue);
  };
  var onMouseDown = function onMouseDown() {
    setIsChanging(true);
  };
  var classNames = classname('range-slider', disabled && 'disabled', valueLabels && 'show-value-labels', hideValueBar && 'hide-value-bar', largeValueLabels && 'large-value-labels', className && className);
  var trackWidth = 100 * (currentValue - minValue) / (maxValue - minValue);
  return /*#__PURE__*/React.createElement("div", _extends({}, remainingProps, {
    className: classNames
  }), /*#__PURE__*/React.createElement("div", {
    className: "range-whole-track"
  }), /*#__PURE__*/React.createElement("div", {
    className: "range-track",
    style: {
      width: "".concat(trackWidth, "%")
    }
  }, valueLabels && /*#__PURE__*/React.createElement("div", {
    className: "range-value"
  }, currentValue)), /*#__PURE__*/React.createElement("input", {
    className: "".concat(isChanging ? 'changing' : ''),
    value: currentValue,
    min: minValue,
    max: maxValue,
    step: step,
    type: "range",
    onChange: handleChange,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp
  }));
};
Slider.defaultProps = {
  step: 1,
  value: 0,
  minValue: 0,
  maxValue: Number.MAX_VALUE,
  valueLabels: false,
  hideValueBar: false,
  disabled: false,
  onChange: function onChange() {},
  onDragEnd: function onDragEnd() {}
};
Slider.propTypes = {
  value: PropTypes.number,
  minValue: PropTypes.number.isRequired,
  maxValue: PropTypes.number.isRequired,
  valueLabels: PropTypes.bool,
  largeValueLabels: PropTypes.bool,
  hideValueBar: PropTypes.bool,
  step: PropTypes.number,
  onChange: PropTypes.func,
  onDragEnd: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool
};
export default Slider;